/**
 * Data civil (`AAAA-MM-DD`) sem deslizar de fuso (E176.F1.C01, GUS-252 item 1).
 *
 * O prazo do caso é uma data, não um instante: o servidor devolve `deadline: "2026-11-05"`. Lido
 * como meia-noite UTC e formatado no fuso do navegador, ele virava 04/11 em Brasília — a lista de
 * casos do perito mostrava a véspera do que a abertura gravou. A data civil é sempre ancorada em UTC nas duas
 * pontas: a leitura (`T00:00:00Z`) e a formatação (`timeZone: 'UTC'`). E o "hoje" que se compara
 * com ela é o dia civil de quem opera, não o dia em UTC (depois das 21h de Brasília, o dia UTC já
 * é amanhã).
 */

const SO_DATA = /^\d{4}-\d{2}-\d{2}$/;

/** `true` quando o valor é uma data civil, sem hora. */
export function eDataCivil(valor: string): boolean {
  return SO_DATA.test(valor);
}

/** A data civil como meia-noite UTC (o mesmo eixo de `diaCivilDeHoje`). */
export function dataCivilEmUtc(dia: string): Date {
  return new Date(`${dia}T00:00:00Z`);
}

/** O dia civil local de `agora`, como meia-noite UTC — comparável com `dataCivilEmUtc`. */
export function diaCivilDeHoje(agora: Date): Date {
  return new Date(Date.UTC(agora.getFullYear(), agora.getMonth(), agora.getDate()));
}
